/**
 * Showing what a merchant pays SeatUp: the price, the GST on it, the total.
 *
 * The server works the figures out (see PaymentTransaction::gstBreakdown) and
 * sends them as `{ base_amount, gst_percent, gst_amount, total_amount }`. This
 * only formats them — calculating GST here as well would be a second copy of
 * the sum that could round a paisa differently from what is charged.
 */

/** ₹999, ₹1,178.82 — paise only when there are any. */
export const inr = (value) => {
  const n = Number(value ?? 0);

  return (
    '₹' +
    n.toLocaleString('en-IN', {
      minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
      maximumFractionDigits: 2
    })
  );
};

/** "18%" rather than "18.00%". */
export const gstRate = (gst) => `${Number(gst?.gst_percent ?? 0)}%`;

/** True when the server sent a breakdown with GST in it. */
export const hasGst = (gst) => Boolean(gst) && Number(gst.gst_amount) > 0;
